module.exports = __webpack_public_path__ + "img/ecology-house.5384d0d6.jpg";